module.exports = __webpack_public_path__ + "media/images/steps/png/255-businessman-5-b791b295ce6cece86f861c1c381b5bfc.png";